import { Fragment, type FC } from 'react';
import { createFragmentContainer, graphql } from 'react-relay/legacy';
import { LocalizedSoldIcon } from 'dibs-elements/exports/LocalizedSoldIcon';
import { LocalizedUnavailableIcon } from 'dibs-elements/exports/LocalizedUnavailableIcon';
import { ClientSuspense } from 'dibs-elements/exports/ClientSuspense';
import { itemStatus } from '../pdpMessages';
import styles from './PdpSharedUnpurchasableHeader.scss';

import { type PdpSharedUnpurchasableHeader_item$data } from './__generated__/PdpSharedUnpurchasableHeader_item.graphql';

type ComponentProps = { item: PdpSharedUnpurchasableHeader_item$data };

const PdpSharedUnpurchasableHeaderComponent: FC<ComponentProps> = ({ item }) => {
    const { title, isSold } = item;
    const UnpurchasableIcon = isSold ? LocalizedSoldIcon : LocalizedUnavailableIcon;

    return (
        <Fragment>
            <div className={styles.title}>{title}</div>
            <div className={styles.statusContainer}>
                <span className={styles.itemStatus}>{itemStatus}</span>
                <span className={styles.iconContainer}>
                    <ClientSuspense fallback={<div className={styles.icon} />}>
                        <UnpurchasableIcon className={styles.icon} />
                    </ClientSuspense>
                </span>
            </div>
        </Fragment>
    );
};

export const PdpSharedUnpurchasableHeader = createFragmentContainer(
    PdpSharedUnpurchasableHeaderComponent,
    {
        item: graphql`
            fragment PdpSharedUnpurchasableHeader_item on Item {
                title
                isSold
            }
        `,
    }
);
